/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Archive_ProductInputs */

const en_lifecycle_archive_product = /** @type {(inputs: Lifecycle_Archive_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive product`)
};

const de_lifecycle_archive_product = /** @type {(inputs: Lifecycle_Archive_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt archivieren`)
};

/**
* | output |
* | --- |
* | "Archive product" |
*
* @param {Lifecycle_Archive_ProductInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_archive_product = /** @type {((inputs?: Lifecycle_Archive_ProductInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Archive_ProductInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_archive_product(inputs)
	return en_lifecycle_archive_product(inputs)
});